// extracted by mini-css-extract-plugin
export default {"formSectionContainer":"formSectionContainer__formSectionContainer--vOMGn","contentContainer":"formSectionContainer__contentContainer--C0KdA"};